// Removed hardcoded SVG injections — we inline ACF-provided SVGs only.

// Load inline SVG by URL into all matched elements
function loadInlineSvg(svgUrl, targetSelector, mode = "replace") {
  if (!svgUrl || !targetSelector) return;
  $.ajax({
    url: svgUrl,
    dataType: "text",
    cache: true,
  })
    .done(function (data) {
      $(targetSelector).each(function () {
        if (mode === "append") {
          $(this).append(data);
        } else if (mode === "prepend") {
          $(this).prepend(data);
        } else {
          $(this).empty().append(data);
        }
      });
    })
    .fail(function () {
      // Silently fail; caller may have fallback
    });
}

// =============================================
// SVG icons
// =============================================

function initializeFancybox() {
  // Fancybox loads per-block (block.json viewScript); it is absent on pages
  // without a video/embed lightbox, so guard against the missing global.
  if (typeof Fancybox === "undefined") {
    return;
  }
  Fancybox.bind("[data-fancybox]", {
    buttons: ["close"],
  });
}

jQuery(document).ready(function ($) {
  // Inject dynamic SVGs provided from PHP (e.g., ACF options)
  if (window.themeSvgs && window.themeSvgs.logo) {
    loadInlineSvg(window.themeSvgs.logo, ".svg-logo");
  }

  // Inline SVGs from ACF repeater
  if (window.themeSvgs && window.themeSvgs.svgs) {
    // 1) Class-based autoload: .svg-<name>, .svg-<name>-before, and .svg-<name>-after
    Object.keys(window.themeSvgs.svgs).forEach(function (name) {
      var url = window.themeSvgs.svgs[name];
      if (url) {
        // Regular replacement: .svg-<name>
        loadInlineSvg(url, ".svg-" + name, "replace");
        // Prepend mode: .svg-<name>-before
        loadInlineSvg(url, ".svg-" + name + "-before", "prepend");
        // Append mode: .svg-<name>-after
        loadInlineSvg(url, ".svg-" + name + "-after", "append");
      }
    });

    // 2) Data attribute support: [data-svg="name"] with optional data-svg-mode
    $("[data-svg]").each(function () {
      var name = $(this).attr("data-svg");
      var mode = $(this).attr("data-svg-mode") || "replace";
      var url = window.themeSvgs.svgs[name];
      if (url) {
        var el = this;
        $.ajax({ url: url, dataType: "text", cache: true })
          .done(function (data) {
            if (mode === "append") {
              $(el).append(data);
            } else if (mode === "prepend") {
              $(el).prepend(data);
            } else {
              $(el).empty().append(data);
            }
          })
          .fail(function () {});
      }
    });
  }

  // Call the function to initialize Fancybox
  initializeFancybox();

  (function initFooterEndorsement() {
    var $widget = $("#footer-endorsement");
    if (!$widget.length) return;

    var delayAttr = $widget.attr("data-endorsement-delay");
    var delayMs = delayAttr ? parseInt(delayAttr, 10) : 5000;
    if (isNaN(delayMs) || delayMs < 0) delayMs = 5000;

    var $link = $widget.find(".footer-endorsement__link");

    setTimeout(function () {
      $widget.addClass("is-visible");
      $widget.attr("aria-hidden", "false");
      $link.removeAttr("tabindex");
    }, delayMs);
  })();

  // Add grouped-content-first and grouped-content-last classes
  $(".sections").each(function () {
    var grouped = $(this).children("section.grouped-content");
    if (grouped.length > 0) {
      grouped.first().addClass("grouped-content-first");
      grouped.last().addClass("grouped-content-last");
    }
  });
});

// ====================================================================
// Emerge.js
// ====================================================================

emergence.init({
  container: window,
  reset: false,
  handheld: true,
  throttle: 10, // Throttle: Time interval in milliseconds for checking element visibility
  elemCushion: 0, // elemCushion: Percentage of an element's height that is considered in view before triggering
  offsetTop: 0,
  offsetRight: 0,
  offsetBottom: 0,
  offsetLeft: 0,
});

// ====================================================================
// Foundation
// ====================================================================

const body = document.body;

// ====================================================================
// Hide and show admin bar
// ====================================================================

document.addEventListener("DOMContentLoaded", function () {
  const adminBar = document.querySelector("#wpadminbar");

  if (adminBar) {
    // Set the initial value of the transform to translateY(-100%)
    adminBar.style.transform = "translateY(-100%)";

    // Listen for mousemove events on the document
    document.addEventListener("mousemove", (event) => {
      // Check if the mouse is near the top of the screen
      if (event.clientY < 20) {
        // Set the transform to translateY(0)
        adminBar.style.transform = "translateY(0)";
      } else {
        // Set the transform to translateY(-100%)
        adminBar.style.transform = "translateY(-100%)";
      }
    });
  }
});

// =============================================
// Toggle navigations function
// =============================================

function toggleMenu(name) {
  const newAttribute = `data-nav-${name}-open`;

  // Close any open overlay
  closeOverlay(newAttribute);

  const willOpen = !(document.body.getAttribute(newAttribute) === "true");
  document.body.setAttribute(newAttribute, willOpen);

  // Keep the toggle button's aria-expanded in sync for screen readers.
  document
    .querySelectorAll(`.btn-hamburger[onclick*="${name}"]`)
    .forEach((btn) => btn.setAttribute("aria-expanded", String(willOpen)));
}

// Function to close any open overlay
function closeOverlay(excludeAttribute) {
  const bodyAttributes = document.body.attributes;

  Array.from(bodyAttributes).forEach((attribute) => {
    if (
      attribute.nodeName.startsWith("data-nav-") &&
      attribute.nodeName.endsWith("-open")
    ) {
      if (attribute.nodeName !== excludeAttribute) {
        document.body.setAttribute(attribute.nodeName, "false");
      }
    }
  });
}

// =============================================
// Observe heights
// =============================================

// Function to observe element height and set CSS variable
function observeElementHeight(elementSelector, cssVariableName) {
  const element = document.querySelector(elementSelector);
  if (!element) {
    return;
  }
  const resizeObserver = new ResizeObserver(() => {
    const elementHeight = $(elementSelector).outerHeight();
    document.documentElement.style.setProperty(
      cssVariableName,
      elementHeight + "px"
    );
  });
  resizeObserver.observe(element);
}

// Observe header height
observeElementHeight(".site-header", "--header-height");

// Observe header height
observeElementHeight(".site-main", "--site-main");

// Observe footer height
observeElementHeight(".site-footer", "--footer-height");

// Observe CTA circle height
if (document.querySelector('[data-layout="h-hero"] .snippet-media')) {
  observeElementHeight(
    '[data-layout="h-hero"] .snippet-media',
    "--hero-circle-height"
  );
}

// =============================================
// Stop Animations During Window Resizing
// =============================================

let resizeTimer;
window.addEventListener("resize", () => {
  document.body.classList.add("window-is-resizing");
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove("window-is-resizing");
  }, 400);
});

$(window).on("load resize", function () {
  var winWidth = $(window).width();
  var maxWidth = 1024;

  if (winWidth < maxWidth) {
    $("body").addClass("mobile-viewport");
  } else {
    $("body").removeClass("mobile-viewport");
  }
});

// ====================================================================
// Show loading/loader animation when page is loading another page
// ====================================================================

// Set the 'data-page-loading' attribute to true when the page is being unloaded
window.addEventListener("beforeunload", () => {
  body.setAttribute("data-page-loading", "true");
});

// Set the 'data-page-loading' attribute to false with a 2-second delay when the page is loaded
window.addEventListener("load", () => {
  // Ensure that 'data-page-loading' is set to 'true' initially
  if (body.getAttribute("data-page-loading") !== "true") {
    body.setAttribute("data-page-loading", "true");
  }

  // Add a 2-second delay before setting 'data-page-loading' to false
  setTimeout(() => {
    // Ensure that 'data-page-loading' is still set to 'true'
    if (body.getAttribute("data-page-loading") === "true") {
      body.setAttribute("data-page-loading", "false");
    }
  }, 3000); // 2000 milliseconds = 2 seconds
});

// ====================================================================
// Has scrolled
// ====================================================================

window.addEventListener("scroll", function () {
  if (window.scrollY > 24) {
    document.body.classList.add("has-scrolled");
  } else {
    document.body.classList.remove("has-scrolled");
  }
});

// ====================================================================
// Transform first section h2 into h1
// ====================================================================

const sections = document.querySelector(".sections");
if (sections) {
  const firstSection = sections.querySelector("section");
  if (firstSection) {
    const h2s = firstSection.querySelectorAll("h2");
    // If first section has multiple h2's, skip to next section
    const targetSection =
      h2s.length > 1 ? firstSection.nextElementSibling : firstSection;

    if (targetSection) {
      const h2 = targetSection.querySelector("h2");
      if (h2) {
        const h1 = document.createElement("h1");
        h1.innerHTML = h2.innerHTML;
        h1.className = h2.className;
        h2.parentNode.replaceChild(h1, h2);
      }
    }
  }
}

// =============================================
// Privacy Policy notice [Accept cookies]
// =============================================

// Cookie function
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

// Function to accept privacy policy
function acceptPrivacyPolicy() {
  document.body.dataset.privacyPolicyAccepted = "true";
  setCookie("privacy_policy_accepted", "true", 365);
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", function () {
  // Check if policy is already accepted
  if (document.cookie.includes("privacy_policy_accepted=true")) {
    document.body.dataset.privacyPolicyAccepted = "true";
  } else {
    document.body.dataset.privacyPolicyAccepted = "false";
  }
});

// ====================================================================
// Download modal with Contact Form 7
// ====================================================================

jQuery(function ($) {
  var $modal = $('#modal-vpa-download-modal');
  var pendingDownloadUrl = '';

  function fillDownloadField() {
    if (!pendingDownloadUrl) return;
    var $field = $modal.find('#download_file');
    if ($field.length) {
      $field.val(pendingDownloadUrl);
      pendingDownloadUrl = '';
    }
  }

  $(document).on('click', 'a[data-download-url][href="#modal-vpa-download-modal"]', function () {
    pendingDownloadUrl = $(this).data('download-url') || '';
    setTimeout(fillDownloadField, 100);
  });

  $modal.on('shown.bs.modal', fillDownloadField);

  document.addEventListener('wpcf7mailsent', function () {
    var downloadUrl = $modal.find('#download_file').val();
    if (downloadUrl) {
      window.open(downloadUrl, '_blank');
    }
  }, false);
});

// ====================================================================
// Imports via Codekit
// ====================================================================


;
// ====================================================================
// Main Menu
// ====================================================================

// =============================================
// Main Menu Constants
// =============================================

const MENU_BREAKPOINT = 1240; // matches $main-menu-bp: xl
const MENU_SELECTOR = '.main-menu';
const MENU_ITEMS_SELECTOR = 'ul.menu > li:has(.sub-menu)';
const TRANSITION_PROPERTIES = ['max-height', 'opacity', 'transform', 'margin-top'];
const RESIZE_DEBOUNCE_DELAY = 250;

// =============================================
// Main Menu Shared Utilities
// =============================================

function getDirectLink(item) {
  // Get the direct child <a> element
  const children = Array.from(item.children);
  return children.find(child => child.tagName === "A") || null;
}

function createTransitionEndHandler(item, subMenu) {
  // Track transition properties to ensure all complete
  const completedProperties = new Set();
  
  const handleTransitionEnd = (e) => {
    if (e.target === subMenu && TRANSITION_PROPERTIES.includes(e.propertyName)) {
      completedProperties.add(e.propertyName);
      // Remove class when all properties have completed
      if (completedProperties.size === TRANSITION_PROPERTIES.length) {
        item.classList.remove("sub-menu-animating");
        subMenu.removeEventListener("transitionend", handleTransitionEnd);
      }
    }
  };
  
  subMenu.addEventListener("transitionend", handleTransitionEnd);
  return handleTransitionEnd;
}

function setupARIA(item, link, subMenu) {
  if (!link || !subMenu) return;
  
  const subMenuId = subMenu.id || "submenu-" + Math.random().toString(36).substr(2, 9);
  if (!subMenu.id) {
    subMenu.id = subMenuId;
  }
  link.setAttribute("aria-haspopup", "true");
  link.setAttribute("aria-expanded", "false");
  link.setAttribute("aria-controls", subMenuId);
  subMenu.setAttribute("role", "menu");
}

function closeAllSubMenus(menuItems, removeAnimating = false) {
  menuItems.forEach((item) => {
    item.classList.remove("sub-menu-open");
    if (removeAnimating) {
      item.classList.remove("sub-menu-animating");
    }
    const link = getDirectLink(item);
    const subMenu = item.querySelector(".sub-menu");
    if (link && subMenu) {
      link.setAttribute("aria-expanded", "false");
    }
  });
}

// =============================================
// Desktop Menu Configuration
// =============================================

function setDesktopMenuTriggerAttribute() {
  // Read CSS variable value
  const root = document.documentElement;
  const triggerValue = getComputedStyle(root).getPropertyValue('--main-menu-desktop-trigger').trim();
  
  // Set data attribute on body for CSS selectors
  if (triggerValue === 'hover' || triggerValue === 'click') {
    document.body.setAttribute('data-desktop-menu-trigger', triggerValue);
  } else {
    // Default to hover if invalid value
    document.body.setAttribute('data-desktop-menu-trigger', 'hover');
  }
}

// =============================================
// Unified Sub-menu Handler
// =============================================

function initializeSubMenus(config) {
  const { viewport, trigger, breakpoint } = config;
  const mainMenu = document.querySelector(MENU_SELECTOR);
  if (!mainMenu) return;

  // For desktop, check if trigger is set to "click"
  if (viewport === 'desktop' && trigger !== 'click') return;

  const menuItems = mainMenu.querySelectorAll(MENU_ITEMS_SELECTOR);

  function isViewport() {
    if (viewport === 'mobile') {
      return window.innerWidth < breakpoint;
    } else {
      return window.innerWidth >= breakpoint;
    }
  }

  function toggleSubMenu(item, event) {
    if (!isViewport()) return;

    const link = getDirectLink(item);
    const subMenu = item.querySelector(".sub-menu");
    if (!link || !subMenu) return;

    const isOpen = item.classList.contains("sub-menu-open");

    // Prevent rapid clicking during animation
    if (item.classList.contains("sub-menu-animating")) {
      return;
    }

    // Close all other sub-menus
    closeAllSubMenus(menuItems, viewport === 'desktop');

    if (!isOpen) {
      // Open this sub-menu
      item.classList.add("sub-menu-animating");
      item.classList.add("sub-menu-open");
      link.setAttribute("aria-expanded", "true");
      event.preventDefault();
      createTransitionEndHandler(item, subMenu);
    } else {
      // Close this sub-menu
      item.classList.add("sub-menu-animating");
      item.classList.remove("sub-menu-open");
      link.setAttribute("aria-expanded", "false");
      createTransitionEndHandler(item, subMenu);
    }
  }

  function findMenuItemWithSubMenu(target) {
    while (target && target !== mainMenu) {
      if (target.tagName === "A" && target.closest("ul.menu")) {
        const menuItem = target.parentElement;
        if (menuItem && menuItem.classList.contains("menu-item") && menuItem.querySelector(".sub-menu")) {
          return menuItem;
        }
        const parentLi = target.closest("li");
        if (parentLi && parentLi.querySelector(".sub-menu") && getDirectLink(parentLi) === target) {
          return parentLi;
        }
      }
      target = target.parentElement;
    }
    return null;
  }

  function handleClick(event) {
    // Only handle clicks on appropriate viewport
    if (!isViewport()) return;

    const menuItem = findMenuItemWithSubMenu(event.target);
    if (menuItem) {
      toggleSubMenu(menuItem, event);
    }
  }

  function handleKeyDown(event) {
    // Only handle keyboard events on appropriate viewport
    if (!isViewport()) return;

    const menuItem = findMenuItemWithSubMenu(event.target);
    if (menuItem) {
      const link = getDirectLink(menuItem);
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggleSubMenu(menuItem, event);
      } else if (event.key === "Escape") {
        const isOpen = menuItem.classList.contains("sub-menu-open");
        if (isOpen) {
          menuItem.classList.remove("sub-menu-open");
          if (link) {
            link.setAttribute("aria-expanded", "false");
            link.focus();
          }
        }
      }
    }
  }

  function handleClickOutside(event) {
    if (!isViewport()) return;

    const clickedInsideMenu = mainMenu.contains(event.target);
    if (!clickedInsideMenu) {
      closeAllSubMenus(menuItems, viewport === 'desktop');
    }
  }

  function handleMenuClose() {
    // Close all sub-menus when main menu closes (mobile only)
    if (viewport === 'mobile') {
      const isMenuOpen = document.body.getAttribute("data-nav-main-open") === "true";
      if (!isMenuOpen) {
        closeAllSubMenus(menuItems, false);
      }
    }
  }

  // Initialize ARIA attributes
  menuItems.forEach((item) => {
    const link = getDirectLink(item);
    const subMenu = item.querySelector(".sub-menu");
    setupARIA(item, link, subMenu);
  });

  // Add event listeners
  mainMenu.addEventListener("click", handleClick);
  mainMenu.addEventListener("keydown", handleKeyDown);
  document.addEventListener("click", handleClickOutside);

  // Close sub-menus when main menu closes (mobile only)
  if (viewport === 'mobile') {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-nav-main-open"
        ) {
          handleMenuClose();
        }
      });
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-nav-main-open"],
    });
  }

  // Reinitialize on window resize (in case viewport crosses breakpoint)
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      if (!isViewport()) {
        closeAllSubMenus(menuItems, viewport === 'desktop');
      }
    }, RESIZE_DEBOUNCE_DELAY);
  });
}

// =============================================
// Main Menu Initialization
// =============================================

let menuInitialized = false;
let desktopMenuInitialized = false;

function initializeMainMenu() {
  // Set desktop menu trigger attribute from CSS variable
  setDesktopMenuTriggerAttribute();
  
  const triggerValue = document.body.getAttribute("data-desktop-menu-trigger") || "hover";
  
  // Initialize mobile sub-menus (only once)
  if (!menuInitialized) {
    initializeSubMenus({
      viewport: 'mobile',
      trigger: 'click',
      breakpoint: MENU_BREAKPOINT
    });
    menuInitialized = true;
  }
  
  // Initialize desktop sub-menus (only if trigger is "click" and not already initialized)
  if (triggerValue === 'click' && !desktopMenuInitialized) {
    initializeSubMenus({
      viewport: 'desktop',
      trigger: 'click',
      breakpoint: MENU_BREAKPOINT
    });
    desktopMenuInitialized = true;
  } else if (triggerValue !== 'click') {
    // Reset flag if trigger changed back to hover
    desktopMenuInitialized = false;
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initializeMainMenu);

// Update data attribute on window resize (in case CSS variable changes)
let resizeTimeout;
window.addEventListener("resize", function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    setDesktopMenuTriggerAttribute();
    // Reinitialize desktop if trigger changed
    const triggerValue = document.body.getAttribute("data-desktop-menu-trigger") || "hover";
    if (triggerValue === 'click' && !desktopMenuInitialized) {
      initializeSubMenus({
        viewport: 'desktop',
        trigger: 'click',
        breakpoint: MENU_BREAKPOINT
      });
      desktopMenuInitialized = true;
    } else if (triggerValue !== 'click') {
      desktopMenuInitialized = false;
    }
  }, RESIZE_DEBOUNCE_DELAY);
});

;
/**
 * Slick init for blocks that render a [data-carousel] wrapper
 * (content-slider, post-grid). The Slick options come from the block
 * template as JSON in the data-carousel attribute; Slick itself is
 * enqueued per block via block.json viewScript.
 */
(function ($) {
    function initCarousels() {
        $('[data-carousel]').each(function () {
            var $carousel = $(this);
            var options = {};

            try {
                options = JSON.parse($carousel.attr('data-carousel') || '{}');
            } catch (e) {
                console.error('Invalid data-carousel JSON', this);
                return;
            }

            // Re-init safe (BrowserSync / ajax refreshes)
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
            $carousel.removeClass('single-slide');

            if ($carousel.children().length <= 1) {
                $carousel.addClass('single-slide');
                return;
            }

            // Show dots only when there are more slides than visible
            $carousel.on('init reInit setPosition', function (event, slick) {
                if (slick.$dots) slick.$dots.toggle(slick.slideCount > slick.options.slidesToShow);
            });

            $carousel.slick(options);
        });
    }

    $(function () {
        if (!$('[data-carousel]').length) {
            return;
        }

        // Slick loads as a block viewScript; retry briefly if it's not ready yet.
        var tries = 0;
        (function attempt() {
            if ($.fn.slick) {
                initCarousels();
            } else if (++tries < 20) {
                setTimeout(attempt, 100);
            } else {
                console.error('Slick carousel library failed to load');
            }
        })();
    });
})(jQuery);
